import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import AlchemyThemeRouting from '../presentationalComponents/AlchemyThemeRouting';
import { updateDraftRequest } from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchFetchAvailableModalitiesV2 } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState) => {
  return {
    themeRoutingData: !!state.ContactState.SelfHelpAlchemyState.alchemyResults ? state.ContactState.SelfHelpAlchemyState.alchemyResults.ThemeRoutingData : null,
    draftRequest: state.ContactState.ModalitySectionState.draftRequest,
    showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    sourceApp: state.GlobalState.sourceApp,
    themeName: state.GlobalState.theme,
  };
};

const mapDispatchToProps = {
    dispatchFetchAvailableModalitiesV2,
    updateDraftRequest,
};

export const AlchemyThemeRoutingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(AlchemyThemeRouting, getContactUsStyles));

export default AlchemyThemeRoutingContainer;
